import { render, staticRenderFns } from "./mastery-degree.vue?vue&type=template&id=fc83d0ee&scoped=true"
import script from "./mastery-degree.vue?vue&type=script&lang=js"
export * from "./mastery-degree.vue?vue&type=script&lang=js"
import style0 from "./mastery-degree.vue?vue&type=style&index=0&id=fc83d0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc83d0ee",
  null
  
)

export default component.exports